/**
 * Converts a UUID to a profile picture URL
 * @param uuid - The UUID stored in the database (without .jpg extension)
 * @returns The relative URL to the profile picture (served by webpack dev server or nginx in production)
 */
export const getProfilePictureUrl = (uuid) => {
    if (!uuid) {
        return null;
    }
    // Use relative path - webpack dev server will serve from uploads folder
    // In production, nginx will serve from uploads folder
    return `/uploads/${uuid}.jpg`;
};
